// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"breadcrumb--35hGM","breadcrumbItem":"breadcrumbItem--1FAlJ"};